export default __webpack_public_path__ + "static/signupMeta-1908f9f696901aed6b577edb0bf587ac.jpg";